"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainScreen = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var doshx_controls_web_1 = require("doshx_controls_web");
var taffyLogo_png_1 = __importDefault(require("../assets/taffyLogo.png"));
// import { faFlame } from "@fortawesome/pro-solid-svg-icons";
var home_1 = require("./pages/home");
var about_us_1 = require("./pages/about_us");
var contact_us_1 = require("./pages/contact_us");
var shop_1 = require("./pages/shop/shop");
var basket_1 = require("./pages/basket/basket");
var log_in_1 = require("./pages/log_in");
var sign_up_1 = require("./pages/sign_up");
var profile_1 = require("./pages/profile/profile");
var react_redux_2 = require("react-redux");
var main_1 = require("../reducers/slices/main");
var product_1 = require("./pages/shop/product");
var checkout_1 = require("./pages/checkout");
var outcome_1 = require("./pages/outcome");
var user_1 = require("../reducers/slices/user");
var forgot_password_1 = require("./pages/forgot_password");
var search_products_1 = require("../api/calls/product/search_products");
var selection_1 = require("../reducers/slices/selection");
var getRootPath_1 = require("../helpers/getRootPath");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var orders_1 = require("./pages/orders/orders");
var details_1 = require("./pages/orders/details");
var newsletter_subscribe_1 = require("../api/calls/user/newsletter_subscribe");
var terms_and_conditions_1 = require("./pages/terms_and_conditions");
var privacy_policy_1 = require("./pages/privacy_policy");
var get_basket_thunk_1 = require("../reducers/slices/basket/thunks/get_basket_thunk");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var hot_deals_1 = require("./pages/hot_deals");
var return_policy_1 = require("./pages/return_policy");
var MainScreen = function () {
    var _a, _b, _c, _d, _e;
    var cookie = new universal_cookie_1.default();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var location = (0, react_router_dom_1.useLocation)();
    var rootPath = (0, getRootPath_1.getRootPath)(location);
    // const [drawerPageName, setDrawerPageName] = useState<"login" | "signup" | "forgot" | "profile">("login");
    var _f = (0, react_1.useState)(""), searchTerm = _f[0], setSearchTerm = _f[1];
    var _g = (0, react_1.useState)([]), searchPredictions = _g[0], setSearchPredictions = _g[1];
    var _h = (0, react_1.useState)(""), subscribingEmail = _h[0], setSubscribingEmail = _h[1];
    var _j = (0, react_1.useState)(""), subscribingEmailError = _j[0], setSubscribingEmailError = _j[1];
    var _k = (0, react_1.useState)(false), isBusySubscribing = _k[0], setIsBusySubscribing = _k[1];
    var main = (0, react_redux_2.useSelector)(function (state) { return state.mainState; }).main;
    var user = (0, react_redux_2.useSelector)(function (state) { return state.userState; }).user;
    var basket = (0, react_redux_2.useSelector)(function (state) { return state.basketState; }).basket;
    (0, react_1.useEffect)(function () {
        var _a;
        document.title = (_a = process.env.APP_NAME) !== null && _a !== void 0 ? _a : "";
    }, []);
    (0, react_1.useEffect)(function () {
        //Get user in the cookie and set it in the store
        var userStateCookie = cookie.get("user_state");
        if (userStateCookie) {
            dispatch((0, user_1.setUser)(userStateCookie));
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (user.user._id) {
            dispatch((0, get_basket_thunk_1.get_basket_thunk)());
        }
    }, [user.user._id]);
    (0, react_1.useEffect)(function () {
        var delayFn = setTimeout(function () {
            if (searchTerm) {
                (0, search_products_1.searchProducts)({
                    search_string: searchTerm,
                }).then(function (response) {
                    // console.log("searchProducts response", response);
                    setSearchPredictions(response.content);
                });
            }
        }, 777);
        return function () { return clearTimeout(delayFn); };
    }, [searchTerm]);
    var openAccountPage = function () {
        if (user.user._id) {
            dispatch((0, main_1.setDrawerPage)("profile"));
            // navigate(`${rootPath}/profile`);
        }
        else {
            dispatch((0, main_1.setDrawerPage)("login"));
            // navigate(`${location.pathname}/login`);
        }
        dispatch((0, main_1.setDrawerOpen)(true));
    };
    var redirectToSocialMediaPage = function (link) {
        // 👇️ directly change the active URL to navigate
        if (link) {
            window.open(link, "_blank");
        }
    };
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "bg-secondary" },
            react_1.default.createElement(doshx_controls_web_1.TopHeaderControl, { colors: {
                    drawer: {
                        backgroundColor: "bg-secondary",
                        textColor: "text-borders-light",
                        divideColor: "divide-borders-gray",
                        close: { iconColor: "text-borders-light", backgroundColor: "bg-secondary" },
                    },
                }, logo: { image: taffyLogo_png_1.default, size: "large", onClick: function () { return navigate("/"); } }, search: {
                    backgroundColor: "bg-white",
                    textColor: "text-secondary",
                    iconColor: "text-secondary",
                    displayKey: "label",
                    options: searchPredictions.map(function (prediction) { return ({
                        label: prediction.title,
                        value: prediction._id,
                    }); }),
                    searchChanged: function (value) {
                        setSearchTerm(value);
                    },
                    searchSelectionChanged: function (value) {
                        dispatch((0, selection_1.setSelectedProduct)({
                            _id: value.value,
                        }));
                        navigate("/product/".concat(value.value));
                    },
                }, account: {
                    displayText: user.user._id ? "".concat(user.user.name, " ").concat(user.user.surname) : undefined,
                    iconColor: "text-secondary",
                    textColor: "text-secondary",
                    backgroundColor: "bg-primary",
                    onClick: function () {
                        openAccountPage();
                    },
                }, basket: {
                    count: (_b = (_a = basket === null || basket === void 0 ? void 0 : basket.product_list) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
                    onClick: function () { return navigate("/basket"); },
                    countBackgroundColor: "bg-white",
                    backgroundColor: "bg-secondary",
                    iconColor: "text-white",
                    countTextColor: "text-secondary",
                }, topBar: {
                    colors: {
                        textColor: "text-secondary",
                        backgroundColor: "bg-primary",
                    },
                    // contactNumber: process.env.CONTACT_SUPPORT_PHONE_NUMBER ?? "",
                    // contactEmail: process.env.CONTACT_SUPPORT_EMAIL_ADDRESS ?? "",
                    // promotionalText: "Here is promotion",
                }, menu: {
                    dropdownBackgroundColor: "bg-primary",
                    backgroundColor: "bg-primary",
                    textColor: "text-secondary",
                    menuItems: [
                        {
                            label: "Home",
                            onClick: function () {
                                navigate("/home");
                            },
                        },
                        {
                            label: "About Us",
                            onClick: function () {
                                navigate("/about-us");
                            },
                        },
                        {
                            label: "Contact Us",
                            onClick: function () {
                                navigate("/contact-us");
                            },
                        },
                        {
                            label: "Shop",
                            onClick: function () {
                                navigate("/shop");
                                // // console.log("location.pathname", location.pathname);
                                if (location.pathname == "/shop") {
                                    // console.log("Reloading same route", location.pathname);
                                    navigate(0);
                                }
                            },
                        },
                        {
                            label: "Hot Deals",
                            iconColor: "text-white",
                            icon: pro_solid_svg_icons_1.faFlame,
                            onClick: function () {
                                navigate("/hot-deals");
                            },
                        },
                    ],
                } })),
        react_1.default.createElement(doshx_controls_web_1.DrawerControl, { open: main.isDrawerOpen, close: {
                backgroundColor: "bg-primary",
            }, toggleOpen: function (v) {
                dispatch((0, main_1.setDrawerOpen)(v));
            } }, (function () {
            switch (main.drawerPageName) {
                case "login":
                    return react_1.default.createElement(log_in_1.SignInPage, null);
                case "signup":
                    return react_1.default.createElement(sign_up_1.SignUpPage, null);
                case "profile":
                    return react_1.default.createElement(profile_1.ProfilePage, null);
                case "forgot":
                    return react_1.default.createElement(forgot_password_1.ForgotPasswordPage, null);
            }
        })()),
        react_1.default.createElement("div", { className: "pt-5 pb-10" },
            react_1.default.createElement(react_router_dom_1.Routes, null,
                react_1.default.createElement(react_router_dom_1.Route, { index: true, element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/home" }) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/home/*", element: react_1.default.createElement(home_1.HomePage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/about-us/*", element: react_1.default.createElement(about_us_1.AboutUsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/contact-us/*", element: react_1.default.createElement(contact_us_1.ContactUsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/shop/*", element: react_1.default.createElement(shop_1.ShopPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/product/:productId", element: react_1.default.createElement(product_1.ProductPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/basket/*", element: react_1.default.createElement(basket_1.BasketPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/checkout/*", element: react_1.default.createElement(checkout_1.CheckoutPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/hot-deals/*", element: react_1.default.createElement(hot_deals_1.HotDealsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/outcome/:actionType/:paymentIdentifier", element: react_1.default.createElement(outcome_1.OutcomePage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/orders", element: react_1.default.createElement(orders_1.OrdersPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/order/details/:orderId", element: react_1.default.createElement(details_1.OrderDetailsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/terms-and-conditions/*", element: react_1.default.createElement(terms_and_conditions_1.TermsAndConditionsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/privacy-policy/*", element: react_1.default.createElement(privacy_policy_1.PrivacyPolicyPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/return-policy/*", element: react_1.default.createElement(return_policy_1.ReturnPolicyPage, null) }))),
        react_1.default.createElement(doshx_controls_web_1.FooterControl, { backgroundColor: "bg-white", newsletter: {
                title: "Sign up for our newsletter",
                description: "Be the first to know about our latest fashion arrivals, exclusive deals, and style tips. Join our fashion-forward community and sign up for our newsletter to stay trendy!",
                backgroundColor: "bg-secondary",
                textColor: "text-white",
                onEmailChange: function (v) { return setSubscribingEmail(v); },
                emailAddress: subscribingEmail,
                input: {
                    errorText: subscribingEmailError,
                },
                button: {
                    backgroundColor: "bg-secondary",
                    textColor: "text-white",
                    loading: isBusySubscribing,
                    onClick: function () {
                        setSubscribingEmailError("");
                        if (!subscribingEmail) {
                            setSubscribingEmailError("Please enter a valid email address.");
                        }
                        else {
                            setIsBusySubscribing(true);
                            (0, newsletter_subscribe_1.newsletter_subscribe)({
                                email: subscribingEmail,
                            }).then(function (response) {
                                setIsBusySubscribing(false);
                                if (response.success) {
                                    setSubscribingEmail("");
                                    dispatch((0, main_1.setMainModal)({ title: "Subscribed!", messages: ["You have successfully subscribed to our newsletter!"] }));
                                }
                                else {
                                    dispatch((0, main_1.setMainModal)({ title: "Something went wrong!", messages: [response.message] }));
                                }
                            });
                        }
                    },
                },
            }, logo: {
                image: taffyLogo_png_1.default,
                size: "large",
            }, description: "At ".concat((_c = process.env.APP_NAME) !== null && _c !== void 0 ? _c : "", ", we don't just clothe you - we strive to make all our clients look and feel confident in their style."), socialMedia: [
                // {
                //   icon: faYoutube,
                //   onClick() {
                //     redirectToSocialMediaPage();
                //   },
                // },
                // {
                //   icon: faInstagram,
                //   onClick() {
                //     redirectToSocialMediaPage();
                //   },
                // },
                // {
                //   icon: faTwitter,
                //   onClick() {
                //     redirectToSocialMediaPage();
                //   },
                // },
                {
                    icon: free_brands_svg_icons_1.faFacebookF,
                    onClick: function () {
                        redirectToSocialMediaPage("https://www.facebook.com/taffyaccessories?mibextid=ZbWKwL");
                    },
                },
                {
                    icon: free_brands_svg_icons_1.faInstagram,
                    onClick: function () {
                        redirectToSocialMediaPage("https://www.instagram.com/taffyaccessories/");
                    },
                },
                {
                    icon: free_brands_svg_icons_1.faWhatsapp,
                    onClick: function () {
                        redirectToSocialMediaPage("https://wa.me/message/6P3ANQJTFJ6GF1");
                    },
                },
                //
            ], shortcut: {
                links: [
                    {
                        label: "About Us",
                        onClick: function () {
                            navigate("/about-us");
                        },
                    },
                    {
                        label: "Contact Us",
                        onClick: function () {
                            navigate("/contact-us");
                        },
                    },
                    {
                        label: "Shop",
                        onClick: function () {
                            navigate("/shop");
                        },
                    },
                    {
                        label: "Login",
                        onClick: function () {
                            // navigate(`${rootPath}/login`);
                            dispatch((0, main_1.setDrawerPage)("login"));
                            dispatch((0, main_1.setDrawerOpen)(true));
                            // openAccountPage();
                        },
                    },
                    {
                        label: "Sign Up",
                        onClick: function () {
                            // navigate(`${rootPath}/signup`);
                            dispatch((0, main_1.setDrawerPage)("signup"));
                            dispatch((0, main_1.setDrawerOpen)(true));
                            // openAccountPage();
                        },
                    },
                    //
                ],
            }, customer: {
                title: "Customer Links",
                links: [
                    { label: "My Account", onClick: function () { return openAccountPage(); } },
                    { label: "Basket", onClick: function () { return navigate("/basket"); } },
                    { label: "Orders", onClick: function () { return navigate("/orders"); } },
                    // { label: "Tracking" },
                    { label: "Terms & Conditions", onClick: function () { return navigate("/terms-and-conditions"); } },
                    { label: "Privacy Policy", onClick: function () { return navigate("/privacy-policy"); } },
                    { label: "Return Policy", onClick: function () { return navigate("/return-policy"); } },
                    //
                ],
            }, contact: {
                title: "Contact",
                description: "Need assistance or have a question? Contact us and we'll be happy to help!",
                // helpText: "Have any questions?",
                phone: {
                    number: (_d = process.env.CONTACT_SUPPORT_PHONE_NUMBER) !== null && _d !== void 0 ? _d : "",
                    title: "Have any questions?",
                    icon: pro_solid_svg_icons_1.faPhone,
                    onClick: function () {
                        // console.log("Clicked Phone");
                    },
                },
                email: {
                    address: (_e = process.env.CONTACT_SUPPORT_EMAIL_ADDRESS) !== null && _e !== void 0 ? _e : "",
                    title: "Want to send us a message?",
                    icon: pro_solid_svg_icons_1.faEnvelope,
                    onClick: function () {
                        // console.log("Clicked Phone");
                    },
                },
            }, scrollWindowToTop: true, copyright: {
                company: "Let'sTrade",
                textColor: "text-secondary",
                backgroundColor: "bg-white",
                position: "center",
                size: "small",
                addPadding: true,
                useScreenContainer: true,
            } }),
        main.modal && (react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: main.modal.title, open: true, onClose: function () {
                // setIsOpen(false);
                dispatch((0, main_1.setMainModal)(null));
            } },
            react_1.default.createElement("div", null, main.modal.messages.map(function (message, index) {
                return react_1.default.createElement("div", { key: "modal-message-".concat(index) }, message);
            }))))));
};
exports.MainScreen = MainScreen;
